import React, {ReactElement} from "react";
import {Translate} from "react-localize-redux";
import "./JobStatus.scss";
import classNames from "classnames";
import {JobTag} from "../../enums/enums";

interface Props {
    status: string
}

const {
    EXPIRED,
    REJECTED: REJECTED_TAG,
    COMPLETED: COMPLETED_TAG,
    APPROVED_FOR_PAYMENT,
}: typeof JobTag = JobTag;

const JobStatus: React.FC<Props> = ({status}: Props): ReactElement => {
    const translatePath: string = "components.JobStatus.JobStatus";
    const activeClass: string = classNames({
        "df-task-normal": status === APPROVED_FOR_PAYMENT,
        "df-task-warning": status === REJECTED_TAG || status === EXPIRED,
        "df-task-success": status === COMPLETED_TAG,
    });

    return (
        <div className="df-job-status">
            <Translate id={`${translatePath}.label.text`}/>
            <span className={activeClass}><Translate id={`${translatePath}.${status}.text`}/></span>
        </div>
    );
};

export default JobStatus;
